var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { bindable } from "aurelia-templating";
import { autoinject } from "aurelia-dependency-injection";
import { I18N } from "aurelia-i18n";
var RenderImageProps = /** @class */ (function () {
    function RenderImageProps(i18N) {
        this.i18N = i18N;
        // The brand's lotteries as link targets ({ value: "lottery/<id>", name }), supplied by the host step.
        this.lotteryOptions = [];
        // When true, only the image uploaders show (no click-through link) - e.g. a banner background image.
        this.hideLink = false;
        this._linkType = "internal";
        this.linkTypeOptions = [
            { id: "internal", name: this.i18N.tr("render-prop-link-internal") },
            { id: "lottery", name: this.i18N.tr("render-prop-link-lottery") },
            { id: "external", name: this.i18N.tr("render-prop-link-external") }
        ];
        this.internalPageOptions = [
            { route: "", name: this.i18N.tr("render-prop-link-none") },
            { route: "/lobby", name: "Lobby" },
            { route: "/lotteries", name: "Lotteries" },
            { route: "/bundles", name: "Bundles" },
            { route: "/results", name: "Results" },
            { route: "/purchases", name: "My Purchases" },
            { route: "/cart", name: "Cart" }
        ];
    }
    RenderImageProps.prototype.bind = function () {
        this.section.props = this.section.props || {};
        this.section.props.image = this.section.props.image || {};
        // Derive the type from the stored value WITHOUT going through the setter (so we don't clear it).
        this._linkType = this.deriveLinkType(this.section.props.link || "");
    };
    RenderImageProps.prototype.deriveLinkType = function (link) {
        if (/^https?:\/\//i.test(link))
            return "external";
        if (/^\/?lottery\//i.test(link))
            return "lottery";
        return "internal";
    };
    Object.defineProperty(RenderImageProps.prototype, "linkType", {
        // Two-way bound to the type combo. Changing the type clears the previously-entered link so the
        // admin always fills the field that matches the chosen type (no stale internal value in the
        // external box, etc.). Empty link = not clickable.
        get: function () {
            return this._linkType;
        },
        set: function (value) {
            if (value && value !== this._linkType) {
                this._linkType = value;
                this.section.props.link = "";
            }
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], RenderImageProps.prototype, "section", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Array)
    ], RenderImageProps.prototype, "lotteryOptions", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], RenderImageProps.prototype, "hideLink", void 0);
    RenderImageProps = __decorate([
        autoinject,
        __metadata("design:paramtypes", [I18N])
    ], RenderImageProps);
    return RenderImageProps;
}());
export { RenderImageProps };
